<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="门诊清单" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>

			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>95271</b>
				</div>
			</div>

			<div class="date-row date-row2 fcc">
				<span class="t">开始日期</span>
				<div class="date fc-bet">

					
					<b>{{value1}}</b>
					<i class="calendar"></i>
					
					
					
					<el-date-picker
					      v-model="value1"
					      type="date"
					      placeholder="选择日期"
						 format="yyyy 年 MM 月 dd 日"
						 value-format="yyyy-MM-dd">
						 >
					    </el-date-picker>
					
					
				</div>
				<span class="t">结束日期</span>
				<div class="date fc-bet">
				
					
					<b>{{value2}}</b>
					<i class="calendar"></i>
					
					
					
					<el-date-picker
					      v-model="value2"
					      type="date"
					      placeholder="选择日期"
						 format="yyyy 年 MM 月 dd 日"
						 value-format="yyyy-MM-dd">
						 >
					    </el-date-picker>
					
					
				</div>
				<button type="button" class="btn-so fcc">
					<img src="../../assets/icon/icon-search.png">
					<span>搜索</span>
				</button>
			</div>

			
			
			<div class="hospital-list">
				<div class="th">
					<div class="col1">收费项目</div>
					<div class="col2">数量</div>
					<div class="col3">单位</div>
					<div class="col4">单价</div>
					<div class="col5">小计</div>
				</div>
				<div class="tbody">
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="name">氯化钠注射液（09%）/250ml：2.25q/瓶</div>
						</div>
						<div class="col2">1</div>
						<div class="col3">瓶</div>
						<div class="col4">15</div>
						<div class="col5">15</div>
					</div>
					<div class="td">
											<div class="col1">
												<div class="name">99氯化钠注射液（09%）/250ml：2.25q/瓶</div>
											</div>
											<div class="col2">1</div>
											<div class="col3">瓶</div>
											<div class="col4">15</div>
											<div class="col5">15</div>
										</div>
				</div>
			</div>
			
			
			
			


			<div class="fc-bet">
				
				<div class="list-page fcc">
					<a>上一页</a>
					<span>第</span>
					<span>1/15</span>
					<span>页</span>
					<a>下一页</a>
				</div>
				<div class="total-price">
					<span> 合计:<b>308.17</b>元</span>
				
				</div>
				
			</div>


			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				<a class="btn-home fcc">
					<img src="../../assets/icon/printer.png" >
					<span>打印</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>

		</div>

	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';

	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle
		},
		data() {
			
			return {
				value1:"",
				value2:""
			}
		},
		mounted() {
			this.value1 = this.getDate({format: true})
			this.value2 = this.getDate({format: true})
		},
		methods: {
			getDate(type) {
				const date = new Date();
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();

				month = month > 9 ? month : '0' + month;
				day = day > 9 ? day : '0' + day;
				return `${year}-${month}-${day}`;
			}
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style  lang="less">

		
	
</style>
